import { render, staticRenderFns } from "./mainComponent.vue?vue&type=template&id=ca8a5c1e"
import script from "./mainComponent.vue?vue&type=script&lang=js"
export * from "./mainComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports